module.exports = __webpack_public_path__ + "static/img/mastercard.ccd3034.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards/mastercard.svg
// module id = mYEf
// module chunks = 1